import { RangeType } from "../../pages/user_center/contents/my_coupons/coupon-enums";

function couponRuleParser(ruleDSL, dataId, dataType, price, renewMode = null) {
  if (price < ruleDSL?.threshold) return false;
  if (ruleDSL?.range?.type === RangeType.ALL) {
    if (!ruleDSL?.range?.data_type?.includes(dataType)) return false;
  } else if (ruleDSL?.range?.type === RangeType.PART) {
    if (!ruleDSL?.range?.data?.[dataType]?.includes(Number(dataId))) return false;
  }
  if (ruleDSL?.renew_only && !renewMode) return false;
  return true;
}
export default couponRuleParser;
